module.exports = __webpack_public_path__ + "img/flor.7f051a38.svg";